import { Injectable } from "@angular/core";
import { BackendService } from "../backend/backend.service";

@Injectable({
  providedIn: "root"
})
export class TestScheduleService {
  private path = "/test-schedules";

  constructor(private backendService: BackendService) {}

  saveImportTestSchedules(testschedule) {
    return this.backendService.post(this.path + "/import", testschedule);
  }

  searchTestSchedules(currPage: number, pageSize: number, filter: any) {
    var data = {
      pagination: {
        page: currPage,
        size: pageSize
      },
      filter: filter
    };

    return this.backendService.post(this.path + "/search", data);
  }

  deleteTestSchedules(id) {
    return this.backendService.post(this.path + "/" + id + "/delete", {});
  }

  getTestSchedulesById(id) {
    return this.backendService.get(this.path + "/" + id);
  }

  saveTestSchedules(candschedule) {
    return this.backendService.post(this.path, candschedule);
  }

  deleteAll(examCenter) {
    return this.backendService.post(this.path + "/delete", examCenter);
  }
}
